import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorPanel } from '../../ErrorPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorCredits = ({
  errorId,
  onSubmit
}) => /*#__PURE__*/_jsx(ErrorPanel, {
  errorId: errorId,
  onSubmit: onSubmit,
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "enrichmentProperties.panel.error.credits.title"
  }),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "enrichmentProperties.panel.error.credits.description"
  })
});